import { render } from "./User.vue?vue&type=template&id=f6a9b67e"
import script from "./User.vue?vue&type=script&lang=js"
export * from "./User.vue?vue&type=script&lang=js"

import "./User.vue?vue&type=style&index=0&id=f6a9b67e&lang=css"

import exportComponent from "/var/jenkins_home/workspace/aws.total-account-site.US/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__